import { PLATFORM } from 'aurelia-pal';

export class ImageValueConverter {
	toView(id, format) {
		return PLATFORM.global.$appConfig.apiRoot + "photos/" + (format || "preview") + "/" + (id || 0);
	}
}
